export default __webpack_public_path__ + "static/media/tag-draft.5501204c.svg";